import { createStore } from 'vuex'

export default createStore({
    state: {
        serverUrl: 'https://control.asallaziz.com',
        storageUrl: 'https://control.asallaziz.com/storage/',
        contents: null,
        content: null,
        banners: null,
        searchResult: null,
        id: null,
        slug: null,
        provinces: null,
        cities: null,
        userToken: null, // This will hold the user token (for Authorization headers)
    },
    mutations: {
        setRouteParams(state, { id, slug }) {
            state.id = id;
            state.slug = slug;
        },
        setContents(state, contents) {
            state.contents = contents;
        },
        setContent(state, content) {
            state.content = content;
        },
        setBanners(state, banners) {
            state.banners = banners;
        },
        setSearchResult(state, searchResult) {
            state.searchResult = searchResult;
        },
        setProvinces(state, provinces) {
            state.provinces = provinces;
        },
        setCities(state, cities) {
            state.cities = cities;
        },

        setUserToken(state, token) {
            state.userToken = token;
        }
    },
    actions: {
        // This function sets the headers for each fetch request
        async setFetchHeaders({ state }) {
            const headers = {
                'Content-Type': 'application/json',
                Accept: "application/json",
                "User-Agent": "PostmanRuntime/7.39.0", // mimic Postman
            };

            if (state.userToken) {
                headers['Authorization'] = `Bearer ${state.userToken}`;
            }

            return headers;
        },

        // Fetch contents from the API
        async getContents({ commit, dispatch, state }, id) {
            const headers = await dispatch('setFetchHeaders');

            try {
                const response = await fetch(`${state.serverUrl}/api/get/contents/${id}`, {
                    method: 'GET',
                    headers: headers,
                });

                if (!response.ok) {
                    throw new Error('Error fetching contents');
                }

                const data = await response.json();
                commit('setContents', data);
            } catch (error) {
                console.error('Error fetching contents:', error);
            }
        },
        // Fetch a specific content using slug
        async getContent({ commit, dispatch, state }, slug) {
            const headers = await dispatch('setFetchHeaders');

            try {
                const response = await fetch(`${state.serverUrl}/api/get/content/${slug}`, {
                    method: 'GET',
                    headers: headers,
                });

                if (!response.ok) {
                    throw new Error('Error fetching contents');
                }

                const data = await response.json();
                commit('setContent', data);
            } catch (error) {
                console.error('Error fetching contents:', error);
            }
        },

        // Fetch banners from the API
        async getBanners({ commit, state }) {
            const headers = await this.dispatch('setFetchHeaders');

            try {
                const response = await fetch(state.serverUrl + '/api/get/banners', {
                    method: 'GET',
                    headers: headers,
                });

                if (!response.ok) {
                    throw new Error('Error fetching banners');
                }

                const data = await response.json();
                commit('setBanners', data);  // Commit the data to the state
            } catch (error) {
                console.error('Error fetching banners:', error);
            }
        },
        async getCities({ commit, dispatch, state }, id) {
            const headers = await dispatch('setFetchHeaders');

            try {
                const response = await fetch(`${state.serverUrl}/api/get/cities?province_id=${id}`, {
                    method: 'GET',
                    headers: headers,
                });

                if (!response.ok) {
                    throw new Error('Error fetching cities');
                }

                const data = await response.json();
                commit('setCities', data);
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        },

        // Fetch banners from the API
        async getProvinces({ commit, state }) {
            const headers = await this.dispatch('setFetchHeaders');

            try {
                const response = await fetch(state.serverUrl + '/api/get/provinces', {
                    method: 'GET',
                    headers: headers,
                });

                if (!response.ok) {
                    throw new Error('Error fetching provinces');
                }

                const data = await response.json();
                commit('setProvinces', data);  // Commit the data to the state
            } catch (error) {
                console.error('Error fetching provinces:', error);
            }
        },
  // Fetch search result from the API
        async getSearchResult({ commit, dispatch, state }, term) {
            const headers = await this.dispatch('setFetchHeaders');

            try {
                const response = await fetch(`${state.serverUrl}/api/search?term=${term}`, {
                    method: 'GET',
                    headers: headers,
                });

                if (!response.ok) {
                    throw new Error('Error fetching search result');
                }

                const data = await response.json();
                commit('setSearchResult', data);  // Commit the data to the state
            } catch (error) {
                console.error('Error fetching search result:', error);
            }
        },

        // Example to set the user token (if necessary)
        setUserToken({ commit }, token) {
            commit('setUserToken', token);
        },
    },
});
